import React from 'react';

const Vision = () => {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-4">Our Vision</h2>

      <div className="row align-items-center">
        {/* Left Column: Text */}
        <div className="col-md-6">
          <p style={{ textAlign: 'justify' }}>
            At <strong>Inovaantage</strong>, we aspire to pioneer agile business solutions that harness the power
            of technology and innovation. We are driven by our unwavering passion for leveraging technology
            to drive meaningful transformation in the corporate landscape.
          </p>
          <p style={{ textAlign: 'justify' }}>
            Our expert team is deeply committed to the belief that well-crafted software can optimize
            resources, boost productivity, and foster business growth. We continue to push the limits of
            what technology can do through constant innovation and research.
          </p>
          <p style={{ textAlign: 'justify' }}>
            By staying ahead of emerging trends and digital capabilities, we aim to create impactful solutions
            that act as catalysts for efficiency, creativity, and sustained success in the modern business world.
            Join us as we redefine the future of digital transformation.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="col-md-6 text-center">
          <img
            src="hyderabad.png"
            alt="Inovaantage Vision"
            className="img-fluid"
            style={{ maxHeight: '350px', objectFit: 'contain' }}
          />
        </div>
      </div>
    </div>
  );
};

export default Vision;
